export default "__VITE_ASSET__BBy52cej__"